
export const DASHBOARD_FETCHING = 'DASHBOARD_FETCHING'
export const DASHBOARD_FAILED = 'DASHBOARD_FAILED'
export const DASHBOARD_FETCHED = 'DASHBOARD_FETCHED' 